import { useNavigate } from 'react-router-dom';

type SortOrder = 'newest' | 'distance';

interface StoreFilterProps {
  sortOrder: SortOrder;
  onSortToggle: () => void;
}

export function StoreFilter({ sortOrder, onSortToggle }: StoreFilterProps) {
  const navigate = useNavigate();

  const handleFilterClick = () => {
    navigate('/view-filter');
  };

  return (
    <section style={{ marginBottom: '0px' }}>
      <div className="bg-[#F5F5F5] flex justify-between items-center" style={{ padding: '12px 0px' }}>
        <button 
          className="flex items-center gap-1 bg-transparent border-none p-0 cursor-pointer"
          onClick={onSortToggle}
          style={{ marginLeft: '4px' }}
        >
          <img 
            src="/icons/icon_arrow_down.svg" 
            alt="정렬 방향" 
            className="w-3.5 h-3.5"
          />
          <span className="text-[14px] text-[#222222]">
            {sortOrder === 'newest' ? '새로운 순' : '가까운 순'}
          </span>
        </button>
        
        <button
          onClick={handleFilterClick}
          className="flex items-center gap-1 border-[0.5px] border-[#222222] px-2 py-1 rounded-lg"
          style={{ marginRight: '4px', borderRadius: '8px' }}
        >
          <img 
            src="/icons/icon_filter.svg" 
            alt="필터" 
            className="w-4 h-4"
          />
          <span className="text-[14px] text-[#222222]">보기 필터</span>
        </button>
      </div>
    </section>
  );
}